import { render, staticRenderFns } from "./IntroOneIdPanel.vue?vue&type=template&id=4131b0e3&"
import script from "./IntroOneIdPanel.vue?vue&type=script&lang=ts&"
export * from "./IntroOneIdPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports